import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductResolver } from '../../../../../resolvers/product.resolver';
import { FlexLoansComponent } from './flex-loans.component';
import { FlexLoanSettlementComponent } from './flex-loan-settlement/flex-loan-settlement.component';

const routes: Routes = [
    {
        path: '',
        component: FlexLoansComponent,
        resolve: {
            product: ProductResolver
        }
    },
    {
        path: 'settlement',
        component: FlexLoanSettlementComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FlexLoansRoutingModule {}